module.exports = __webpack_public_path__ + "static/img/comparar.82f1253.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/comparar.gif
// module id = +Ts4
// module chunks = 0